/** @namespace styleTypes */
export default {
  ok: "ok",
  neutral: "neutral",
  error: "error",
};
